import { getLoginApiUrl } from '@/constants/customInfo';
import util from '@/util';
import eventBus from '@/EventBus';
import $http from '@/http/index';
import moment from 'moment';

/* 카티니 커스텀 */
const postCartiniLogin = () => {
  return new Promise((resolve, reject) => {
    $http({
      url: getLoginApiUrl(),
      method: 'POST',
      data: {
        loginId: util.encryptByAES256(util.parseLoginToken().loginId)
      }
    })
      .then((response) => {
        if (response && response.headers && response.headers['authorization']) {
          if (localStorage.getItem('cartini-auth-token')) {
            localStorage.removeItem('cartini-auth-token');
          }
          localStorage.setItem('cartini-key', response.headers['authorization'].replace('Bearer ', ''));
        }
        resolve();
      })
      .catch((error) => {
        eventBus.$emit('DialogPopup', {
          useDialog: true,
          messageHTML: `<p class="txt">${error.translate}</p>`
        });
        reject(error);
      });
  });
};

const checkTokenStatus = () => {
  try {
    if (!localStorage.getItem('cartini-key') || !util.parseToken(localStorage.getItem('cartini-key'))) {
      return true;
    }
    const exp = util.parseToken(localStorage.getItem('cartini-key')).exp;
    if (!exp) {
      return false;
    }
    const expirationTime = exp.toString().length === 10 ? moment(exp * 1000) : moment(exp);
    const current = moment();
    return moment(expirationTime).diff(current, 'hours') <= 4;
  } catch (e) {
    console.log('e', e);
    return false;
  }
};

const checkTokenNeeded = (cb) => {
  if (checkTokenStatus()) {
    postCartiniLogin()
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
      })
      .catch(() => {
        if (typeof cb === 'function') {
          cb();
        }
      });
  } else {
    if (typeof cb === 'function') {
      cb();
    }
  }
};

export { checkTokenNeeded };



// WEBPACK FOOTER //
// ./src/util/custom.js